import { Combobox, ComboboxButton, ComboboxInput, ComboboxOption, ComboboxOptions, Label } from '@headlessui/react'
export type {
  ComboboxProps as HeadlessComboboxProps,
  ComboboxButtonProps as HeadlessComboboxButtonProps,
  ComboboxInputProps as HeadlessComboboxInputProps,
  LabelProps as HeadlessComboboxLabelProps,
  ComboboxOptionProps as HeadlessComboboxOptionProps,
  ComboboxOptionsProps as HeadlessComboboxOptionsProps
} from '@headlessui/react'

export const HeadlessCombobox = Object.assign(Combobox, {
  Options: ComboboxOptions,
  Option: ComboboxOption,
  Input: ComboboxInput,
  Label: Label,
  Button: ComboboxButton
})
